import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Storage } from "./storage.actions";
import { StorageStateModel } from "./storage.model";
import { STORAGE_STATE } from "../index";
import { Injectable } from '@angular/core';

@State<StorageStateModel>({
  name: STORAGE_STATE,
  defaults: {
    productId: undefined,
    metricId: undefined,
    refreshToken: undefined,
    accessToken: undefined,
    rememberMe: false
  }
})
@Injectable()
export class StorageState {
  @Selector()
  static selectedProductId({ productId }: StorageStateModel) {
    return productId;
  }

  @Selector()
  static metricId({ metricId }: StorageStateModel) {
    return metricId;
  }

  @Selector()
  static refreshToken({ refreshToken }: StorageStateModel) {
    return refreshToken;
  }

  @Selector()
  static accessToken({ accessToken }: StorageStateModel) {
    return accessToken;
  }

  @Action(Storage.SetSelectedProductId)
  setProductId({ patchState }: StateContext<StorageStateModel>, { productId }: Storage.SetSelectedProductId) {
    patchState({
      productId
    });
  }

  @Action(Storage.SetSelectedMetricId)
  setMetricId({ patchState }: StateContext<StorageStateModel>, { metricId }: Storage.SetSelectedMetricId) {
    patchState({
      metricId
    });
  }

  @Action(Storage.ClearSelectedProductId)
  clearProductId({ patchState }: StateContext<StorageStateModel>) {
    patchState({
      productId: undefined
    });
  }

  @Action(Storage.SetAccessToken)
  setAccessToken({ patchState }: StateContext<StorageStateModel>, { accessToken }: Storage.SetAccessToken) {
    patchState({
      accessToken
    });
  }

  @Action(Storage.SetRefreshToken)
  setRefreshToken({ patchState }: StateContext<StorageStateModel>, { refreshToken }: Storage.SetRefreshToken) {
    patchState({
      refreshToken
    });
  }

  @Action(Storage.ClearAccessRefreshToken)
  clearAccessRefreshToken({ patchState }: StateContext<StorageStateModel>) {
    patchState({
      accessToken: undefined,
      refreshToken: undefined
    });
  }

  @Selector()
  static rememberMe(state: StorageStateModel) {
    return state.rememberMe
  }

  @Action(Storage.RememberMe)
  setRememberMe({ patchState }: StateContext<StorageStateModel>, { value }: Storage.RememberMe) {
    patchState({
      rememberMe: value
    })
  }
}
